// Utils
import { convertToQueryStringValues } from '../../common/utils/stringUtil';

// Services
import { http } from '../utils/services/http';
import { asyncResource } from '../utils/services/http/asyncResource/asyncResource';

// Constants
import { ResourceTypes } from '../utils/services/http/asyncResource/asyncResourceConstants';

export const fetchCmsData =
    (key: string, forceFetch = false) =>
    (params?: Record<string, any>) =>
    (dispatch: Function) =>
        dispatch(
            asyncResource(
                ResourceTypes.cms,
                key,
                forceFetch,
            )(() =>
                http({
                    url: `cms/${key}`,
                    timeout: 15000,
                    retry: 3,
                    // We need to do this instead of directly providing the params so that the segments array
                    // gets correctly converted into a string format
                    params: convertToQueryStringValues(params),
                }),
            ),
        );
